import "@pergamenos/shared/theme/theme.css";
import "./style.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./i18n.ts";
import { initPlatform } from "./platform/host.ts";

// The API client reads the host's settings when it is first imported.
try {
  await initPlatform();
} catch (e) {
  console.error("desktop shell settings could not be read:", e);
}
const { App } = await import("./app/App.tsx");
const { startSession } = await import("./session.ts");
const { initOffline } = await import("./offline/sync.ts");
void initOffline();

createRoot(document.getElementById("app") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
void startSession();
